export const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5,
        slidesToSlide: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3,
        slidesToSlide: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2,
        slidesToSlide: 1
    }
};

export const ArrayImage = [
    { id: "1", image: "/image/slider/1.png" },
    { id: "2", image: "/image/slider/2.png" },
    { id: "3", image: "/image/slider/3.png" },
    { id: "4", image: "/image/slider/4.png" },
    { id: "5", image: "/image/slider/5.png" },
    { id: "6", image: "/image/slider/6.png" },
    { id: "7", image: "/image/slider/7.png" },
    { id: "8", image: "/image/slider/8.png" },
    { id: "9", image: "/image/slider/9.png" },
    { id: "10", image: "/image/slider/10.png" },
    { id: "11", image: "/image/slider/11.png" },
    { id: "12", image: "/image/slider/12.png" },
    { id: "13", image: "/image/slider/13.png" },
    { id: "14", image: "/image/slider/14.png" }
]